export default __webpack_public_path__ + "static/shutterstock-cb4ac8f5d054151cbd89be7d11bf852b.jpg";